import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Footer from '../../components/Footer';
import SubHeader from '../../components/SubHeader';
import MoreOfOurWork from './MoreOfOurWork';
import { removeHeroAnimation } from '../../actions/sharedPiecesActions';
import SectionLoader from '../../components/common/SectionLoader/SectionLoader'
import { useSingleCaseStudy } from '../../util/queryFunctions';
import DetailsOurWorkContent from './DetailsOurWorkContent';
import NotFound from '../NotFound/NotFound';
import GreenGlyph from '../../images/logos/nurelm-glyph-green.svg'

export const OW_DETAILS_TITLE = "NuRelm - Our Work";
export const OW_DETAILS_HERO_TITLE = 'Our Work';

//TODO Need to add the image ALT anywhere used, if != null

const DetailsOurWork = ({
  match,
  history,
  location,
  removeHeroAnimation: removeHeroAnimationFn
}) => {
  const { data, isFetching } = useSingleCaseStudy(match.params.slug)

  useEffect(() => {
    document.title = OW_DETAILS_TITLE;
    removeHeroAnimationFn();
    window.scrollTo(0, 0);
  }, [removeHeroAnimationFn])
  //TODO: We need to think about what's going on setting the title here... we set it differently in 2 spots which
  // seems like it could cause issues

  useEffect(() => {
    if (isFetching || !data) return;
    if(data.title !== undefined && document.title !== "NuRelm - " + data.title.rendered) {
      document.title = "NuRelm - " + data.title.rendered;
    }
  }, [data, isFetching])

  if (isFetching) {
    return (
      <div className="content-container loader-thelab">
        <SectionLoader />;
      </div>
    )
  }

  if (!isFetching && !data) return (
    <NotFound
      history={history}
      location={location} />
  );

  return (
    <div>
      <div className="our-work-details">
        <SubHeader
          heroOverrides={{
            heroTitle: OW_DETAILS_HERO_TITLE,
            heroHeadline: data ? data.acf.hero_headline : 'Loading...',
            heroCopy: data ? data.acf.hero_copy : ''
          }}
          history={history}
          location={location}
          glyphColor={GreenGlyph}
        />
        <main>
          <div className="content-container no-padding">
            <div className="details-content">
              <DetailsOurWorkContent data={data} />
              <MoreOfOurWork ourWorkItemId={data.id}/>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default connect(null, { removeHeroAnimation })(DetailsOurWork);
